<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Reset Fixture Activations
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        Reset fixture activations to 0 for serial number {{this.fixture.serialNumber}}?
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="#f5f5f5" @click="onChangeClick()">Reset</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    fixture: Object,
  },

  data() {
    return {

    };
  },

  methods: {
    onChangeClick() {
      this.$emit('close', { serialNumber: this.fixture.serialNumber });
    },

    onCancelClick() {
      this.$emit('close', { serialNumber: null });
    },
  },
};
</script>
